export const changeCssProperty = (element, cssProperties) => {
    if (cssProperties.length < 1) {
        return;
    }
    for (let i = 0; i < cssProperties.length; i++) {
        element.style.setProperty(cssProperties[i].cssPropertyName, cssProperties[i].cssPropertyValue);
    }
};
//# sourceMappingURL=changeCssProperty.js.map